import { render, staticRenderFns } from "./modalInfoAmostra.vue?vue&type=template&id=7826b790"
import script from "./modalInfoAmostra.vue?vue&type=script&lang=js"
export * from "./modalInfoAmostra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports